import { ref, nextTick, computed } from 'vue'
import Schema from 'async-validator'
import { clone } from '@/common/js/just.js'
import { mergeDeep } from '@/common/js/utils.js'

import { creativeFormV3Rules } from '@/views/create/gdt/model/creative-rules.js'
import { PLATFORM, MEDIAS } from '@/common/js/constants.js'
import { getV3CreativeForm } from '@/views/create/gdt/model/creative-form.js'
import { AD_MARKETING_SCENE } from '../../model/project-const.js'

export const usePlanConfigForm = (configForm) => {
  const formRef = ref(null)
  const showPlanInfoModal = ref(false)

  const isSearchAd = computed(() => {
    const { ad_marketing_scene } = configForm.value.planForm
    return ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SEARCH
  })

  const methods = {
    getFormFileds: () => formRef.value.getForm(),
    /**
     * @description: 供父组件调用
     * @return {*}
     */
    async validate() {
      return Promise.resolve()
    },

    /**
     * @description: 广告表单校验
     */
    formValidator: (done) => {
      formRef.value
        .validate()
        .then(done)
        .catch((e) => {
          const errorElement = document.querySelector('.plan-info .el-form-item__error')
          errorElement?.scrollIntoView({ block: 'center', behavior: 'smooth' })
          console.log('validate error output: ', e)
        })
    },
    async onShowConfigModal() {
      showPlanInfoModal.value = true
      const { creativeForm, planForm, accounts } = configForm.value
      const defaultForm = getV3CreativeForm.call({ planForm: configForm.value.planForm })
      // 试玩素材默认取第一个账号
      defaultForm.components.wxgame_playable_material_config.account = clone(accounts[0])
      const form = Object.values(creativeForm).length
        ? mergeDeep(defaultForm, creativeForm)
        : { ...defaultForm, dynamic_creative_name: planForm.project_name }

      nextTick(() => {
        formRef.value.setForm(form)
      })
    }
  }

  return {
    isSearchAd, formRef, showPlanInfoModal, methods
  }
}
